import { CAT_NECESSARY, CAT_ANALYTICS } from "../constants";

const translation = {
  consentModal: {
    title: "Agahdariya کوکی",
    description:
      "Em کوکیyên pêwîst bi kar tînin da ku malper rast bixebite. Hêdî jî em کوکیyên şopandina hilbijartî bi kar tînin da bizanin tu çawa bi malperê me re têkilî dikî. Ev کوکیyên hilbijartî tenê bi destûra te saz dibin.",
    acceptAllBtn: "Hemûyan qebûl bike",
    acceptNecessaryBtn: "Hemûyan red bike",
    showPreferencesBtn: "Vebijêrkên taybetî rêveberî bike",
  },
  preferencesModal: {
    title: "Rêveberiya vebijêrkên کوکی",
    acceptAllBtn: "Hemûyan qebûl bike",
    acceptNecessaryBtn: "Hemûyan red bike",
    savePreferencesBtn: "Qebûlkirina hilbijartina niha",
    closeIconLabel: "Pence binge",
    sections: [
      {
        title: "Bikaranîna کوکی",
        description:
          "Em کوکی bi kar tînin da fûnksiyona bingehîn a malperê biparêzin û tecrûbeya gerînê te baştir bikin.",
      },
      {
        title: "کوکیên Bi Gelemperî Pêwist",
        description: "Ev کوکی ji bo xebata rast a malperê pêwîst in, wek mînak nasandina bikarhêner.",
        linkedCategory: CAT_NECESSARY,
        cookieTable: {
          headers: { name: "Nav", domain: "Xizmet", description: "Terîf", expiration: "Dema qedandinê" },
          body: [
            {
              name: "_care_leavers_social_hub_session",
              domain: "www.secure-messaging.co.uk",
              description: "کوکی hatî saz kirin ji hêla Platforma Civaka Dijîtalê bo nasandina bikarhêner.",
              expiration: "Seshîn",
            },
            {
              name: "CSRF-TOKEN",
              domain: "www.secure-messaging.co.uk",
              description: "کوکی hatî saz kirin ji hêla Platforma Civaka Dijîtalê bo nasandina bikarhêner",
              expiration: "Seshîn",
            },
            {
              name: "__cf_bm",
              domain: ".www.secure-messaging.co.uk",
              description:
                "Ev کوکی ji bo cuwarkirina mirov û bot tê bikaranîn da xatirê malperê ji xerabîya otomatik biparêze. Daneyên kesane ne têne berhevkirin.",
              expiration: "30 deqîqe",
            },
          ],
        },
      },
      {
        title: "Analîz",
        description:
          "کوکیên analîtîk alîkar dikin dane derbarê bikaranînê hildan ku xizmetan bizanin bikarhêner çawa bi xizmeta xas re têkilî dike. Ev zanîn rê dide çêkirina naverok û fûnksiyona baştir bo ceznê bikarhêner.",
        linkedCategory: CAT_ANALYTICS,
        cookieTable: {
          headers: { name: "Nav", domain: "Xizmet", description: "Terîf", expiration: "Dema qedandinê" },
          body: [
            {
              name: "_ga",
              domain: "Google Analytics",
              description:
                'کوکی hatî saz kirin ji hêla <a href="https://business.safety.google/adscookies/">Google Analytics</a>',
              expiration: "Dema qedandinê: 12 roj piştî hatî qedandinê",
            },
            {
              name: "_gid",
              domain: "Google Analytics",
              description:
                'کوکی hatî saz kirin ji hêla <a href="https://business.safety.google/adscookies/">Google Analytics</a>',
              expiration: "Seshîn",
            },
          ],
        },
      },
    ],
  },
};

const servicesLabel = "Depokirina têkildar bi analîz dike çalak dike, mînak demjimêra serdanê.";

export { translation, servicesLabel };
